import React from "react";

const StatusRevoked = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 1.33c5.893 0 10.67 4.777 10.67 10.67S17.893 22.67 12 22.67 1.33 17.893 1.33 12 6.107 1.33 12 1.33zm-.58 5.363c-1.47-1.47-3.783-1.54-5.166-.158-1.382 1.383-1.312 3.695.158 5.165.96.96 2.28 1.324 3.466 1.075l.562.56-5.167 4.827.816.774 13.38-12.499-.816-.773-5.576 5.209-.607-.607c.295-1.213-.06-2.584-1.05-3.573zm3.268 5.79l-2.093 1.955-.037.757 1.262.007.07 1.226 1.256-.006.091 1.325 2.354.011a.227.227 0 00.227-.236l-.085-1.992-3.045-3.046zM7.054 7.336c.356-.356.95-.338 1.329.04.378.378.396.973.04 1.33-.355.355-.95.337-1.328-.042-.379-.378-.397-.973-.041-1.328z"
      fill="#BDBDBD"
      fillRule="nonzero"
    />
  </svg>
);

export default StatusRevoked;
